import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetContractEmbedded = (contractId, studentId, bodyDta) => {
    const {
        isLoading, data: contractEmbedded, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/contracts/${contractId}/embedded-view`],
        queryFn: () => axiosManager.post$(`/parent/api/students/${studentId}/contracts/${contractId}/embedded-view`, bodyDta).then((response) => response?.data),
        enabled: !!contractId && !!bodyDta,
        retry: 0,
        cacheTime: 0,
        keepPreviousData: false,
    });

    const isContractCompleted = error?.response?.data === "Contract already completed";

    return {
        isLoading,
        isRefetching,
        contractEmbedded,
        error,
        refetch,
        isContractCompleted,
    };
};
